/**
 * TrainingScreen (Screen 3 / Game-Based)
 * 
 * "Verbal Training That Fits Your Day."
 * STANDARD viewport = original hardcoded values (the baseline).
 */
import React from 'react';
import { useOnboardingViewport } from '../shared/useViewport';

export const GameBasedScreen = ({ onNext, onBack }) => {
  const vp = useOnboardingViewport();

  const primaryCTAStyle = {
    width: "100%",
    height: `${vp.spacing.ctaHeight}px`,
    background: "#14B8A6",
    borderRadius: `${vp.spacing.ctaBorderRadius}px`,
    border: "none",
    boxShadow: "0 8px 16px rgba(20, 184, 166, 0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    color: "white",
    fontSize: `${vp.spacing.ctaFontSize}px`,
    fontWeight: "900",
    cursor: "pointer",
    transition: "transform 0.2s",
  };

  const isDesktop = vp.isTablet;
  const isSmallScreen = vp.isSmall;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      width: '100%',
      maxWidth: isDesktop ? '480px' : '100%',
      margin: isDesktop ? '0 auto' : undefined,
      animation: 'fadeIn 0.6s ease-out',
      position: 'relative',
      background: 'transparent',
      transform: 'none',
      transformOrigin: 'top center'
    }}>


      {/* Decorative Elements Layer */}
      <div style={{ position: 'absolute', top: '15%', left: '5%', zIndex: 1, opacity: 0.4 }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M12 2l2 7h7l-5.5 4 2 7-5.5-4-5.5 4 2-7-5.5-4h7l2-7z" fill="#2DD4BF" opacity="0.3" />
        </svg>
      </div>
      <div style={{ position: 'absolute', top: '28%', right: '10%', zIndex: 1 }}>
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" opacity="0.6">
          <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="#8B5CF6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <div style={{ position: 'absolute', top: '38%', left: '25%', zIndex: 1, opacity: 0.3 }}>
        <svg width="40" height="40" viewBox="0 0 60 60" fill="none">
          <path d="M10 30c10-3 20-3 30 0" stroke="#2DD4BF" strokeWidth="2" strokeLinecap="round" strokeDasharray="4 4" />
        </svg>
      </div>

      {/* Headline Area */}
      <div style={{ textAlign: 'center', zIndex: 2, position: 'relative', marginTop: '0px' }}>
        <h2 style={{
          fontSize: vp.sp('clamp(30px, 8.5vw, 36px)', 'clamp(34px, 9vw, 40px)', 'clamp(36px, 9.5vw, 44px)'),
          fontWeight: '900',
          lineHeight: '1.05',
          color: '#0F172A',
          margin: 0,
          letterSpacing: '-2px'
        }}>
          Verbal Training<br />
          That <span style={{ color: '#14B8A6' }}>Fits Your Day.</span>
        </h2>

        <p style={{
          fontSize: '15px',
          color: '#64748B',
          lineHeight: '1.5',
          marginTop: '14px',
          fontWeight: '500',
          padding: '0 20px',
          margin: '14px auto 0',
          maxWidth: '320px'
        }}>
          5-minute games that you can play while waiting for coffee, on the commute or between study sessions.
        </p>
      </div>

      {/* Hero Image — flex:1 fills remaining space naturally */}
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        zIndex: 5,
        padding: `${vp.sp(10, 20, 20)}px 0`
      }}>
        <img
          src="/images/onboarding/page3.webp"
          alt="Game Cards Visualization"
          style={{
            width: '100%',
            height: 'auto',
            maxWidth: '380px',
            display: 'block',
            objectFit: 'contain',
            filter: 'drop-shadow(0 10px 30px rgba(0,0,0,0.05))'
          }}
        />
      </div>

      {/* Bottom CTA */}
      <div style={{
        paddingTop: `${vp.sp(12, 20, 20)}px`,
        zIndex: 10
      }}>
        <button
          onClick={onNext}
          style={primaryCTAStyle}
        >
          This looks fun
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default GameBasedScreen;
